import { useState } from "react";

import { const_var, params } from "../../redux/reducers/reducer.js";
import { showToaster } from "../../screen-share/components/Toaster.tsx";
import { SaveDefaultBuilding } from "../../services/building-service.js";
import { mapLean, getDoorSize, appendFormData } from "../defaultBuilding/defaultbuilding.helper.js";

const getLean = (leantoArr = [], type) => {
	const lean = leantoArr.find((item) => item.leanto_type === type);
	return lean ? mapLean(lean) : [];
};

export const SaveButton = ({ postData }) => {
	const [loading, setLoading] = useState(false);
	const isIntelEdit = const_var?.is_intel_edit;
	const handleClick = async () => {
		if (loading) return;

		try {
			setLoading(true);

			const building = postData?.building || {};

			const defaultBuilding = {
				building_id: const_var.UniqueDefaultBuildingId,
				priceBookId: const_var?.default_price_book_id,
				central_roof_pitch: building.roof_pitch,

				default_doors: (building?.entry_points || []).map((entry) => ({
					component: entry.entry_type,
					type: entry.component_name,
					category: entry.entry_type,
					wall: entry.component_wall_name,
					size: getDoorSize(entry?.entry_size),
					position: entry.entry_position
				})),

				heavy_snow: 0,

				image_name: const_var?.default_Image_object?.name || const_var?.default_building_data?.configData?.image_name,

				leanto_data: {
					front: getLean(building.leanto, 3),
					back: getLean(building.leanto, 4),
					right: getLean(building.leanto, 2),
					left: getLean(building.leanto, 1),
					gable_front: getLean(building.leanto, 5),
					gable_back: getLean(building.leanto, 6)
				},

				manufacturer_id: const_var?.default_manufacturer_id,
				name: building?.building_type_name,
				roof_color: building?.roof_color?.id,
				roof_id: building?.roof_style,
				size: `${building.width}x${building.length}x${building.height}`,
				trim_color: building?.trim_color?.id,
				utility: params.p_u_t,
				wainscot_color: building?.wainscot?.id,

				wall: {
					front: building.front_wall,
					back: building.back_wall,
					right: building.right_wall,
					left: building.left_wall
				},

				wall_color: building?.wall_color?.id,
				siding_material: const_var?.selSidingObj?.materialSubTypeId || "",
				is_vertical: params.p_v_w
			};

			const payload = {
				manufacturerId: const_var?.default_manufacturer_id,
				priceBookId: const_var?.default_price_book_id,
				buildingId: const_var?.default_building_id,

				...(isIntelEdit && {
					defaultBuildingId: const_var?.default_building_data?.id,
					isIntelEdit: true
				}),

				name: building?.building_type_name,
				configData: defaultBuilding,

				createdBy: const_var?.default_user_id || "135a0986-47b0-4e3d-8fe6-d4d34c2fb005",

				image: const_var?.default_Image_object?.object || const_var?.default_building_data?.imageUrl
			};

			const formData = new FormData();

			appendFormData(formData, {
				manufacturerId: payload.manufacturerId,
				priceBookId: payload.priceBookId,
				buildingId: payload.buildingId,
				...(isIntelEdit && {
					isIntelEdit: payload.isIntelEdit,
					defaultBuildingId: payload.defaultBuildingId
				}),
				name: payload.name,
				createdBy: payload.createdBy,
				configData: JSON.stringify(payload.configData),
				image: payload.image
			});

			const response = await SaveDefaultBuilding(formData);

			if (response) {
				showToaster(isIntelEdit ? "Default Building Updated Successfully" : "Default Building Saved Successfully");
			}
		} catch (error) {
			console.error("API Error:", error);
			showToaster(error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div>
			<button className="btn btn-block btn-primary btn-share" onClick={handleClick} disabled={loading}>
				{loading ? (isIntelEdit ? "Updating..." : "Saving...") : isIntelEdit ? "Update" : "Save"}
			</button>
		</div>
	);
};
